export const DISPLAY_MODE_OPTIONS = [
  { label: '资源展示', value: '资源展示' },
  { label: '集合展示', value: '集合展示' },
]

/** 样式类型 pill：按 styleType 字符串 hash 分配稳定 tone，避免每行随机变色。 */
const STYLE_TYPE_TONES = [
  'sky',
  'violet',
  'teal',
  'amber',
  'rose',
  'indigo',
  'link',
]

export function getStyleTypeVariant(styleType) {
  const raw = String(styleType == null ? '' : styleType)
  if (!raw) return 'neutral'
  let hash = 0
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash * 31 + raw.charCodeAt(i)) >>> 0
  }
  return STYLE_TYPE_TONES[hash % STYLE_TYPE_TONES.length]
}

export function formatGridSize(columNum) {
  const n = Number(columNum)
  if (!Number.isFinite(n) || n <= 0) {
    return '—'
  }
  return `${n}×${n}`
}

export function getDisplayModeLabel(displayMode) {
  const value = String(displayMode || '').trim()
  return value || '—'
}

export function getShowTitleLabel(isShowTitle) {
  if (isShowTitle === true || isShowTitle === 1 || isShowTitle === '1') {
    return '显示'
  }
  if (isShowTitle === false || isShowTitle === 0 || isShowTitle === '0') {
    return '不显示'
  }
  return '—'
}

export function isShowTitleEnabled(isShowTitle) {
  return isShowTitle === true || isShowTitle === 1 || isShowTitle === '1'
}
